import { useContext } from 'react';
import { CloudinaryTrackerContext } from '../../components/CloudinaryTrackerProvider/CloudinaryTrackerProvider';

export const useCloudinaryTracker = () => {
  const tracker = useContext(CloudinaryTrackerContext);
  return tracker;
};
